module.exports = __webpack_public_path__ + "static/media/bg7.0de9173c.png";